// extracted by mini-css-extract-plugin
module.exports = {"gamePreview":"Preview_gamePreview__k_Ue1"};